<template>
  <div class="purchase-wrapper" v-if="showTyingSale">
    <div class="row">
      <div class="row-label">
        <img class="row-label-icon" src="@/assets/icons/ConvenientlyPurchase.svg" alt="顺手购" />
      </div>
      <div class="row-content">
        <div class="row-content-title">
          <img class="title-icon" src="@/assets/icons/gift.png" alt="" />
          <span class="title-text">{{ tyingSceneDesc }}</span>
        </div>
        <div class="tying-sales-container">
          <div class="product-info-wrapper" v-for="item in tyingSaleSchemaList" :key="item.saleSchemaId">
            <div class="product-info">
              <div class="product-title">{{ item.saleSchemaName || '-' }}</div>
              <div class="product-introduce" v-if="introduce(item)">{{ introduce(item) }}</div>
              <div class="product-prop-wrapper">
                <span class="property-item">{{ $t('有效期：') }}{{ calculateEffectiveTime(item) }}</span>
                <!--订单详情页数据saleInfoTotalNum（顺手购产品规格数）-->
                <span class="property-item">
                  {{ $t('产品规格：') }}{{ isOrderDetail ? item.saleInfoTotalNum : item.totalNum }} {{ item.units }}
                </span>
              </div>
              <div class="price-wrapper">
                <span class="price">￥{{ item.discountPrice && item.discountPrice.toFixed(2) }}</span>
                <span class="special-offer-label">
                  <span class="special-offer-label-text">{{ $t('专属特惠') }}</span>
                </span>
                <span class="origin-price">{{ $t('原价') }}{{ item.originalPrice && item.originalPrice.toFixed(2) }}</span>
              </div>
            </div>
            <es-checkbox class="tying-check" v-model="item.checked" @change="value => checkChange(value, item)"></es-checkbox>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { $t } from '@/locales'
import { mapState } from 'vuex'
import { orderSourceMap } from '@esign/esign-client-jssdk'
import tsignDataTrack from '@tsign/tsigndata-sdk-js'

export default {
  name: 'ConvenientlyPurchase',
  props: {
    // 主商品是否选择了续延生效
    isContinuedValidityTerm: {
      type: Number,
      default: 2,
    },
  },
  data() {
    return {
      // 顺手购商品列表
      tyingSaleSchemaList: [],
      tyingSceneDesc: '',
      sourceChannel: Number(sessionStorage.getItem('source_channel')) || 0,
      showTyingSale: false, // 是否展示顺手购
      // 顺手购商品续延资格缓存
      tyingSaleRenewalCache: {},
    }
  },
  computed: {
    ...mapState({
      userInfo: state => state.userInfo,
      isOrg: state => state.isOrg,
      tsignData: state => state.tsignData,
    }),
    // 是否来自下单页
    isOrderDetail() {
      return this.$route.query.orderId && this.$route.query.sourceFrom === 'comfirm'
    },
  },
  created() {
    this.initData()
  },
  methods: {
    // 商品介绍处理
    introduce(item) {
      return item.commoditySaleDisplay?.introduce || item.introduce
    },
    // 初始化顺收购数据
    initData() {
      // 来自下单页跳转过来的支付页需要查询展示顺收购
      if (this.isOrderDetail) {
        this.getTiyingSceneOrderInfos()

        return
      }
      // 有些场景会无menuId则不展示顺收购
      if (this.$route.query.menuId) {
        this.getTiyingSceneeneSaleInfos()
      }
    },
    // 计算有效期
    calculateEffectiveTime(data) {
      let unit = ''
      if (data.saleType === 2) {
        unit = $t('无限')
      }
      if (data.saleType === 1 || data.saleType === 3) {
        if (data.isUnLimitTime) {
          unit = $t('无限')
        } else {
          if (data.effectiveUnit === 'DAY') {
            unit = $t('{slot1}天', { slot1: data.effectiveDate })
          } else if (data.effectiveUnit === 'YEAR') {
            unit = $t('{slot1}年', { slot1: data.effectiveDate })
          } else if (data.effectiveUnit === 'MONTH') {
            unit = $t('{slot1}月', { slot1: data.effectiveDate })
          }
        }
      }

      return unit || '--'
    },
    // 获取顺收购订单商品
    getTiyingSceneOrderInfos() {
      const oid = this.userInfo.orgId ? this.userInfo.orgId : localStorage.getItem('ouid')
      this.$ajax(this.$url.getTyingRecordOrders(oid), {
        orderId: this.$route.query.orderId,
        payStatus: 0,
      }).then(res => {
        const { tyingSceneDesc, orderDetailModels } = res.data || {}
        this.tyingSceneDesc = tyingSceneDesc
        this.tyingSaleSchemaList = (orderDetailModels || []).map(item => {
          return {
            ...item,
            discountPrice: item.price,
            orderId: item.id,
            saleSchemaName: item.saleInfoName,
            checked: true, // 订单接口返回的搭售商品都是被选中的
          }
        })
        this.showTyingSale = this.tyingSaleSchemaList.length > 0
        this.$emit('onTyingSaleSelectChange', this.tyingSaleSchemaList)
      })
    },
    // 获取顺收购商品
    async getTiyingSceneeneSaleInfos() {
      const oid = this.userInfo.orgId ? this.userInfo.orgId : localStorage.getItem('ouid')
      const client = orderSourceMap[this.sourceChannel] || 'other'
      this.$ajax(this.$url.getTyingSceneSaleInfo(oid, client), {
        saleSchemaId: this.$route.query.menuId || '',
        sourceChannel: this.sourceChannel,
      }).then(res => {
        const { tyingSceneDesc, tyingSaleSchemaList } = res.data || {}
        this.tyingSceneDesc = tyingSceneDesc
        this.tyingSaleSchemaList = (tyingSaleSchemaList || []).map(item => {
          return {
            ...item,
            checked: false, // 当前搭售商品是否被选中
          }
        })
        this.showTyingSale = this.tyingSaleSchemaList.length > 0
        if (this.showTyingSale) {
          this.tyingSaleSchemaList.forEach(item => {
            this.reportSourceChannel('order_bundlingShow', {
              bundling_commodity_id: item.saleSchemaId, // 此处上传售卖方案id，
              bundling_commodity_name: item.saleSchemaName, // 此处上传售卖方案名称，
            })
          })
        }
      })
    },
    // 查询顺手购商品续延资格
    async checkTyingSaleRenewalEligibility(productId) {
      // 如果缓存中已存在该商品的查询结果，直接返回缓存结果
      if (this.tyingSaleRenewalCache[productId]) {
        return this.tyingSaleRenewalCache[productId]
      }

      try {
        // 调用getHistoryUsed接口查询顺手购商品续延资格
        // 顺手购商品的saleSchemaId固定为18
        const params = {
          saleSchemaId: 18,
          productId: productId,
        }

        const res = await this.$ajax(this.$url.getHistoryUsed(), params)
        const isEligible = Boolean(res?.data?.haveOrders && res?.data?.lastEndTime)

        // 缓存查询结果
        this.tyingSaleRenewalCache[productId] = isEligible

        return isEligible
      } catch (error) {
        console.error('查询顺手购商品续延资格失败:', error)
        // 查询失败时默认不可续延
        this.tyingSaleRenewalCache[productId] = false

        return false
      }
    },
    // 搭售商品选择更新
    async checkChange(value, item) {
      // 更新选中状态
      item.checked = value

      // 如果勾选了商品且主商品选择了续延生效，则查询该商品的续延资格
      if (value && this.isContinuedValidityTerm === 1) {
        await this.checkTyingSaleRenewalEligibility(item.productId)
      }

      const selectedList = this.tyingSaleSchemaList.filter(item => item.checked)

      // 将续延资格缓存传递给父组件
      this.$emit('onTyingSaleSelectChange', selectedList, this.tyingSaleRenewalCache)

      // 勾选顺手购埋点上报
      if (value) {
        this.reportSourceChannel('order_bundlingChoose', {
          bundling_commodity_id: item.saleSchemaId, // 此处上传售卖方案id，
          bundling_commodity_name: item.saleSchemaName, // 此处上传售卖方案名称，
        })
      }
    },
    // 埋点上报
    // eslint-disable-next-line camelcase
    reportSourceChannel(type, { bundling_commodity_id, bundling_commodity_name }) {
      const personOid = localStorage.getItem('ouid')
      const personGid = localStorage.getItem('guid')
      const data = {
        bundling_commodity_id,
        bundling_commodity_name,
        user_type: this.isOrg ? '企业' : '个人',
        oid: this.isOrg ? this.userInfo.orgId : personOid,
        gid: this.isOrg ? this.userInfo.gid : personGid,
        geren_oid: personOid,
        geren_gid: personGid,
        order_source: orderSourceMap[this.sourceChannel] || 'other',
      }
      tsignDataTrack.track(type, data)
    },
  },
}
</script>

<style lang="less" scoped>
.purchase-wrapper {
  margin-top: 24px;
  .row {
    display: flex;
    margin-bottom: 24px;
    .row-label {
      width: 72px;
      font-weight: 400;
      font-size: 14px;
      line-height: 32px;
      color: #333;
      flex-shrink: 0;
      &-icon {
        width: 45px;
      }
    }
    .row-content {
      flex: 1;
      width: calc(100% - 72px);
      border-radius: 4px;
      border: 1px solid #FFF5F2;
      background: linear-gradient(90deg, rgba(255, 253, 242, 0.5) 0%, rgba(255, 252, 242, 0.5) 100%);
      &-title {
        width: 100%;
        padding: 5px 12px;
        background: linear-gradient(90deg, #FFF8E5 0%, #FFF8E4 100%);
        display: flex;
        align-items: center;
        .title-icon {
          width: 18px;
          height: 18px;
          margin-right: 8px;
        }
        .title-text {
          font-weight: 400;
          font-size: 12px;
          line-height: 22px;
          color: #A4814E;
        }
      }
    }
    .tying-sales-container {
      padding: 0 16px;
    }
    .product-info-wrapper {
      padding: 8px 0;
      display: flex;
      align-items: center;
      justify-content: space-between;
      border-top: 1px solid #fff7e4;
      &:last-child {
        border-bottom: none;
      }
    }
    .product-info {
      padding-right: 8px;
      .product-title {
        font-weight: 600;
        font-size: 14px;
        line-height: 22px;
        color: #000000;
        word-break: break-all;
      }
      .product-introduce {
        font-weight: 400;
        font-size: 12px;
        line-height: 17px;
        color: #999999;
        margin-top: 2px;
        word-break: break-all;
      }
      .product-prop-wrapper {
        margin-top: 8px;
        .property-item {
          height: 25px;
          border-radius: 4px;
          padding: 2px 4px;
          font-weight: 400;
          font-size: 12px;
          line-height: 17px;
          color: #999999;
          margin-right: 11px;
          border: 1px solid #f5f5f5;
          &:last-child {
            margin-right: 0;
          }
        }
      }
      .price-wrapper {
        margin-top: 12px;
        display: flex;
        align-items: center;
        span {
          margin-right: 8px;
        }
        .price {
          font-weight: 600;
          font-size: 16px;
          line-height: 22px;
          color: #a4814e;
        }
        .special-offer-label {
          display: inline-block;
          font-weight: 400;
          font-size: 12px;
          line-height: 19px;
          padding: 0 4px;
          color: #93470e;
          background: linear-gradient(90deg, #ffd892 1.5%, #faeec9 56%, #fed692 100%);
          border-radius: 4px;
        }
        .special-offer-label-text {
          /* 设置渐变背景 */
          background-image: linear-gradient(90deg, rgba(123, 93, 47, 0.7) 0%, rgba(147, 71, 14, 0.7) 54.5%, rgba(123, 93, 48, 0.7) 100%);
          /* 关键步骤：将背景裁剪至文字区域 */
          -webkit-background-clip: text; /* Safari/Chrome 兼容前缀 */
          background-clip: text;
          /* 隐藏文字原色，显示渐变背景 */
          color: transparent;
          margin: 0;
        }
        .origin-price {
          font-weight: 400;
          font-size: 12px;
          line-height: 17px;
          text-decoration: line-through;
          color: #99999999;
        }
      }
    }
    .tying-check {
      margin-right: 4px;
      flex-shrink: 0;
    }
  }
}

</style>
